<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Associate <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i>
                Record Entry </h1>
            <div class="content-wrap">
                <h3 class="form-hd">Fill the form below to enter record.</h3>
                <form [formGroup]="form">
                    <br>
                    <div formArrayName="StudentDocVerificationRequest"
                        *ngFor="let time of form.controls.StudentDocVerificationRequest?.value; let i = index; trackBy:trackByFn">
                        <div [formGroupName]="i">
                            <div class="col-md-3"  [hidden]="i>0">
                                <div class="form-group input-group-lg">
                                    <label for="OriginalDOCuploadfilePath" class="form-label">Upload Document</label>
                                    <input formControlName="originalDOCuploadfilePath" type="file"
                                        class="form-control form-input border-none" id="originalDOCuploadfilePath"
                                        accept=".png,.jpg,.jpeg,.tiff,,.pdf"
                                        (change)="catchEvent($event.target.files, i)">
                                    <div class="invalid-feedback">
                                        <div>Upload Document is required</div>
                                    </div>
                                    <div *ngIf="fileSizeErr">
                                        <p style="color:#dc3545;font-size:100% ;">File size should be below 1MB.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <!-- <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="firstName" class="form-label">First Name</label>
                                        <input placeholder="FirstName" formControlName="firstName"
                                            class="form-control form-input">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="lastName" class="form-label">Last Name</label>
                                        <input placeholder="LastName" formControlName="lastName"
                                            class="form-control form-input">
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="enrollmentNo" class="form-label">Seat No.</label>
                                        <input placeholder="Enter Seat No." formControlName="enrollmentNo"
                                            class="form-control form-input">
                                    </div>
                                </div>
                            <!-- </div>
                            <div class="row"> -->
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="stream" class="form-label">Stream</label>
                                        <select formControlName="stream" class="form-control form-input" id="stream"
                                            placeholder="Select Your Stream"
                                            (change)='getBranAndStream($event.target.value,i)'>
                                            <option value="" disabled selected> Please select Stream
                                            </option>
                                            <option *ngFor="let stream of streamDropDown" [ngValue]="stream.id">
                                                {{stream.streamName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="branch" class="form-label">Branch</label>
                                        <select formControlName="branch_nm" class="form-control form-input"
                                            id="branch_nm">
                                            <option value="" disabled selected> Please select Branch </option>
                                            <option *ngFor="let branch of branchDropDown[i]"
                                                [ngValue]="branch.branchName">
                                                {{branch.branchName}}</option>
                                        </select>
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="semester" class="form-label">Semester</label>
                                        <select formControlName="semester" class="form-control form-input" id="semester">
                                            <option value="" disabled selected> Please select Semester </option>
                                            <option *ngFor="let semester of semesterDropDown[i]"
                                                [ngValue]="semester.semester">
                                                {{semester.semester}}</option>
                                        </select>
                                    </div>
                                </div>
                            <!-- </div>
                            <div class="row">                                -->
                                <!-- <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="CollegeName" class="form-label">College Name</label>
                                        <select formControlName="collegeName" class="form-control form-input"
                                            id="collegeName">
                                            <option value="" disabled selected> Please select College
                                            </option>
                                            <option *ngFor="let college of collegeDropDown"
                                                [ngValue]="college.collegeName">
                                                {{college.collegeName}}</option>
                                        </select>
                                    </div>
                                </div> -->
                                <div class="col-md-3">
                                    <div class="form-group input-group-lg">
                                        <label for="passingYear" class="form-label">Year of Passing</label>
                                        <!-- <select formControlName="passingYear" class="form-control form-input"
                                            id="passingYear">
                                            <option value="" disabled selected> Please select Year Of
                                                Passing </option>

                                            <option *ngFor="let year of YearOfPassDropDown"
                                                [ngValue]="year.yearOfPassing">
                                                {{year.yearOfPassing}}</option>
                                        </select> -->
                                        <mat-form-field>
                                            <input matInput [matDatepicker]="dp" placeholder="Select Month and Year"  autocomplete="off"
                                                formControlName="yearAndMonthSelect" [matDatepickerFilter]=dateFilter>
                                            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                                            <mat-datepicker #dp startView="multi-year"
                                                (yearSelected)="chosenYearHandler($event)"
                                                (monthSelected)="chosenMonthHandler($event, dp,i)"
                                                panelClass="example-month-picker">
                                            </mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                                
                                <div class="col-md-3" hidden>
                                    <div class="form-group input-group-lg">
                                        <label for="requesttype" class="form-label">Request Type</label>
                                        <select formControlName="requesttype" class="form-control form-input"
                                            id="requesttype">
                                            <option value="" disabled selected> Please select Request Type </option>
                                            <option *ngFor="let request of RequestTypeDropDown" [ngValue]="request.id">
                                                {{request.requestType}}</option>
                                        </select>
                                    </div>
                                </div>
                                <input placeholder="filepath" formControlName="filepath" hidden>
                            </div>
                            <!-- <div class="form-group input-group-lg" hidden>
                                <label for="paymentId" class="form-label" [(ngmodel)]="paymentId"
                                    formControlName="paymentId">{{paymentId}}</label>
                            </div> -->
                        </div>
                        <button class="delete-btn" (click)="removeGroup(i)"><i class="fa fa-minus-circle fa-icon"
                                aria-hidden="true"></i>Remove </button>
                    </div>
                    <br>
                    <button class="add-more-btn" (click)="addGroup()"
                        [disabled]="form.get('StudentDocVerificationRequest').invalid"> <i
                            class="fa fa-plus-circle fa-icon" aria-hidden="true"></i>Add More</button>
                    <button class="proceed-btn" hidden #closebuttonRemark></button>
                    <button class="proceed-btn bg-theme"  (click)="onSubmit()">Submit</button>
                    <!-- data-target="#confirmData"  data-toggle="modal" -->
                </form>
                <div *ngIf="showErr == true">
                    <p style="color:#dc3545;font-size:100% ;">Please enter values in all fields.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #confirmDatas class="modal fade" id="confirmData" tabindex="-1" role="dialog" let-c="close"
let-d="dismiss"  aria-hidden="true">
    <!-- <div class="modal fade"  id="confirmData" tabindex="-1" role="dialog"
    aria-labelledby="viewModalLabel" aria-hidden="true"> -->
    <!-- <div class="modal-dialog modal-dialog-centered modal-xl" role="document"> -->
        <div class="modal-content">
        <div class="modal-header bg-theme">
            <h5 class="modal-title" id="viewModalLabel">Confirm Data</h5>
            <button type="button" class="close" #closebutton2 data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
            <div class="col-md-12">
                <h3 class="page-subhd1">Uploaded Records</h3>
                <div class="table-responsive">
                <table class="ui celled table hover">
                    <thead>
                    <tr>
                        <!-- <th>Student Name</th>
                            <th>Student Surname</th> -->
                        <th>Seat Number</th>
                        <th>Stream</th>
                        <!-- <th>Branch</th> -->
                        <th>Semester</th>
                        <th>Passing Year</th>
                        <!-- <th>College Name</th> -->

                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of acceptedData">
                        <!-- <td>{{data.firstName}}</td>
                            <td>{{data.lastName}}</td> -->
                        <td>{{data.enrollmentNo}}</td>
                        <td>{{data.stream}}</td>
                        <!-- <td>{{data.branch_nm}}</td> -->
                        <td>{{data.semester}}</td>
                        <!-- <td>{{data.passingYear}}</td> -->
                        <td>{{data.monthOfPassing}}/{{data.passingYear}}</td>
                        <!-- <td>{{data.collegeName}}</td> -->

                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            <div class="col-md-12">
                <h3 class="page-subhd2">Rejected Records</h3>
                <div class="table-responsive">
                <table class="ui celled table hover">
                    <thead>
                    <tr>
                        <!-- <th>Student Name</th>
                            <th>Student Surname</th> -->
                        <th>Seat Number</th>
                        <th>Stream</th>
                        <!-- <th>Branch</th> -->
                        <th>Semester</th>
                        <th>Passing Year</th>
                        <!-- <th>College Name</th> -->
                        <th>Reason</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of rejectedData">
                        <!-- <td>{{data.firstName}}</td>
                            <td>{{data.lastName}}</td> -->
                        <td>{{data.enrollmentNo}}</td>
                        <td>{{data.stream}}</td>
                        <!-- <td>{{data.branch_nm}}</td> -->
                        <td>{{data.semester}}</td>
                        <td>{{data.monthOfPassing}}/{{data.passingYear}}</td>
                        <!-- <td>{{data.collegeName}}</td> -->
                        <td>{{data.reason}}</td>

                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </div>
            <button class="proceed-btn bg-theme" (click)="closeAll()">Ok</button>
        </div>
        </div>
    <!-- </div> -->
    <!-- </div> -->
</ng-template>







<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>